// extracted by mini-css-extract-plugin
export default {"text-input":"Textarea_text-input__3YTNg"};